export enum AgeLimitType {
  AgeAtQuote = 'AGEATQUOTE',
  AgeAtReturn = 'AGEATRETURN',
  AgeAtDeparture = 'AGEATDEPARTURE',
}
